/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1UserRequestModel } from '../../entities/v1/UserRequestModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1RequestStateStringSchema } from './requestStateStringSchema'
import { z } from 'zod'

export const v1UserRequestModelSchema = z.object({
  created_at: z.string(),
  deleted_at: z.string().optional(),
  drivee_city_id: z.number().int(),
  first_name: z.string(),
  is_active: z.boolean(),
  last_name: z.string(),
  middle_name: z.string(),
  phone: z.string(),
  public_id: z.number().int(),
  state: z.lazy(() => v1RequestStateStringSchema),
}) as unknown as ToZod<V1UserRequestModel>